import { createContext, useContext, useEffect, useState } from 'react';
import { db } from '../firebaseConfig';
import { doc, onSnapshot } from 'firebase/firestore'; // notice: doc + onSnapshot
import { useUser } from './UserContext';

const AccountContext = createContext();

export function AccountProvider({ children }) {
  const { appUserAccountNumber } = useUser();

  const [accountStatus, setAccountStatus] = useState(null);
  const [accountSubscriptionFrequency, setAccountSubscriptionFrequency] = useState(null);
  const [accountSubscriptionPlan, setAccountSubscriptionPlan] = useState(null);
  const [accountSubscriptionType, setAccountSubscriptionType] = useState(null);
  const [accountCreatedDate, setAccountCreatedDate] = useState(null);
  const [accountStripeCustomerId, setAccountstripeCustomerId] = useState(null);
  const [accountDodoCustomerId, setAccountDodoCustomerId] = useState(null);
  const [accountPaddleCustomerId, setAccountPaddleCustomerId] = useState(null);
  const [accountPaddleSubscriptionId, setAccountPaddleSubscriptionId] = useState(null);

  const [accountLoading, setAccountLoading] = useState(true);

  useEffect(() => {
    if (!appUserAccountNumber) return;

    const accountDocRef = doc(db, "appAccounts", appUserAccountNumber);

    const unsubscribe = onSnapshot(accountDocRef, (accountSnapshot) => {
      if (!accountSnapshot.exists()) {
        console.warn('Account document does not exist');
        return;
      }

      const accountData = accountSnapshot.data();

      setAccountStatus(accountData.status);
      setAccountSubscriptionFrequency(accountData.subscriptionFrequency);
      setAccountSubscriptionPlan(accountData.subscriptionPlan);
      setAccountSubscriptionType(accountData.subscriptionType);
      setAccountCreatedDate(accountData.createdDate);
      setAccountstripeCustomerId(accountData?.stripeCustomerId || null);
      setAccountDodoCustomerId(accountData?.dodoCustomerId || null);
      setAccountPaddleCustomerId(accountData?.paddleCustomerId || null);
      setAccountPaddleSubscriptionId(accountData?.paddleSubscriptionId || null);

      setAccountLoading(false);
    }, (error) => {
      console.error('Error listening to account data:', error);
    });

    return () => unsubscribe(); // Very important! Cleanup on unmount
  }, [appUserAccountNumber]);

  return (
    <AccountContext.Provider value={{ 
      accountStatus, 
      accountSubscriptionFrequency, 
      accountSubscriptionPlan, 
      accountSubscriptionType,
      accountCreatedDate, 
      accountStripeCustomerId,
      accountDodoCustomerId,
      accountPaddleCustomerId,
      accountPaddleSubscriptionId,
      accountLoading 
    }}>
      {children}
    </AccountContext.Provider>
  );
}

export function useAccount() {
  return useContext(AccountContext);
}
